import { InterventionTypeColorEnum, InterventionTypeEnum } from 'api/carVerification/enums/InterventionTypeEnum';
import { VerificationType } from 'api/carVerification/enums/VerificationType';
import colors from 'styles/export/colors.module.scss';

export const getInterventionTypeStatusColor = (type: InterventionTypeEnum) => {
	return { textColor: colors.white, color: InterventionTypeColorEnum[type] };
};

export const isTripLikeVerification = (type?: unknown) =>
	type === VerificationType.TRAVEL || type === VerificationType.HOURS_UTILIZATION;
